import {Component} from "react"
import {Mobile, Notebook, PC, Tablet} from "../../ReactiveMode"
import KakaoMap from "../../../components/component/KakaoMap"

class Directions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: "route-1",
            isLoading: true,
            mapLoaded: false,
        }
    }

    componentDidMount() {
        // 페이지 로딩 애니메이션
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 500)

        // 모바일 탭 초기화
        this.initializeTabs()

        // 스크롤 애니메이션 초기화
        this.initializeScrollAnimations()

        // 지도 로딩 상태 관리
        this.handleMapLoad()
    }

    componentWillUnmount() {
        // 이벤트 리스너 정리
        this.cleanupEventListeners()
    }

    initializeTabs = () => {
        const tabButtons = document.querySelectorAll(".tab-button")
        const tabPanels = document.querySelectorAll(".tab-panel")

        tabButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const targetTab = e.target.getAttribute("data-tab")
                this.switchTab(targetTab, tabButtons, tabPanels)
            })
        })
    }

    switchTab = (targetTab, tabButtons, tabPanels) => {
        // 모든 탭 버튼과 패널에서 active 클래스 제거
        tabButtons.forEach((btn) => btn.classList.remove("active"))
        tabPanels.forEach((panel) => panel.classList.remove("active"))

        // 클릭된 탭 버튼에 active 클래스 추가
        const activeButton = document.querySelector(`[data-tab="${targetTab}"]`)
        if (activeButton) {
            activeButton.classList.add("active")
        }

        // 해당 탭 패널에 active 클래스 추가
        const activePanel = document.getElementById(targetTab)
        if (activePanel) {
            activePanel.classList.add("active")

            // 탭 전환 애니메이션
            activePanel.style.opacity = "0"
            activePanel.style.transform = "translateY(10px)"

            setTimeout(() => {
                activePanel.style.transition = "all 0.3s ease"
                activePanel.style.opacity = "1"
                activePanel.style.transform = "translateY(0)"
            }, 50)
        }

        // 상태 업데이트
        this.setState({activeTab: targetTab})
    }

    initializeScrollAnimations = () => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px",
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animate-in")
                }
            })
        }, observerOptions)

        // 애니메이션 대상 요소들 관찰
        const animateElements = document.querySelectorAll(".info-section, .route-card, .directions-map")
        animateElements.forEach((el) => observer.observe(el))

        this.scrollObserver = observer
    }

    handleMapLoad = () => {
        // 지도 로딩 완료 처리
        setTimeout(() => {
            this.setState({mapLoaded: true})
        }, 1000)
    }

    cleanupEventListeners = () => {
        if (this.scrollObserver) {
            this.scrollObserver.disconnect()
        }
    }

    // 연락처 클릭 핸들러
    handleContactClick = (phoneNumber) => {
        if (window.confirm(`${phoneNumber}로 전화를 걸까요?`)) {
            window.location.href = `tel:${phoneNumber}`
        }
    }

    // 지도 확대 핸들러
    handleMapExpand = () => {
        // 지도 전체화면 모드 (실제 구현 시 모달 등 사용)
        alert("지도 확대 기능 - 실제 구현 시 전체화면 모달로 표시됩니다.")
    }

    render() {
        const {activeTab, isLoading, mapLoaded} = this.state

        // 셔틀버스 데이터
        const shuttleRoutes = [
            {
                id: "route-1",
                number: "1호차",
                name: "가능동방면",
                contact: "백원숙 권사 010-6298-7298 (1부) / 한계석집사 010-8736-4166 (2부)",
                schedules: [
                    {
                        service: "주일 1부 예배",
                        departure: "8:40 출발",
                        stops: [
                            {name: "의공고앞(고려부동산)", time: "8:50"},
                            {name: "크리스탈제과점", time: "8:55"},
                            {name: "하나은행", time: "9:00"},
                            {name: "교회 도착", time: "9:10", isArrival: true},
                        ],
                    },
                    {
                        service: "주일 2부 예배",
                        departure: "09:55 출발",
                        stops: [
                            {name: "가능초교", time: "10:05"},
                            {name: "세븐일레븐", time: "11:00"},
                            {name: "가능1동주민센터", time: "11:02"},
                            {name: "크리스탈제과점", time: "11:05"},
                            {name: "가능프라자", time: "11:07"},
                            {name: "하나은행", time: "11:08"},
                            {name: "교회 도착", time: "11:20", isArrival: true},
                        ],
                    },
                ],
            },
            {
                id: "route-2",
                number: "2호차",
                name: "녹양동방면",
                contact: "김은배 장로 010-6227-6418",
                schedules: [
                    {
                        service: "주일 1부 예배",
                        departure: "8:45 출발",
                        stops: [
                            {name: "현대힐스테이트", time: "8:58"},
                            {name: "누가약국", time: "9:00"},
                            {name: "새마을금고", time: "9:00"},
                            {name: "타이어마을", time: "9:00"},
                            {name: "교회 도착", time: "9:05", isArrival: true},
                        ],
                    },
                    {
                        service: "주일 2부 예배",
                        departure: "10:50 출발",
                        stops: [
                            {name: "법원", time: "10:58"},
                            {name: "현대힐스테이트", time: "11:00"},
                            {name: "누가약국", time: "11:00"},
                            {name: "새마을금고", time: "11:00"},
                            {name: "타이어마을", time: "11:03"},
                            {name: "교회 도착", time: "11:10", isArrival: true},
                        ],
                    },
                ],
            },
            {
                id: "route-3",
                number: "3호차",
                name: "장암동방면",
                contact: "백원숙 권사 010-6296-7298",
                schedules: [
                    {
                        service: "주일 2부 예배",
                        departure: "10:43 출발",
                        stops: [
                            {name: "장암@ 정문", time: "10:43"},
                            {name: "발곡중 정문", time: "10:45"},
                            {name: "호원동한신@ 뒷편", time: "11:05"},
                            {name: "교회 도착", time: "11:20", isArrival: true},
                        ],
                    },
                ],
            },{
                id: "route-4",
                number: "새벽 예배",
                name: "가능,녹양방면",
                contact: "김은배 장로 010-6227-6418",
                schedules: [
                    {
                        service: "새벽 예배",
                        departure: "04:10 출발",
                        stops: [
                            {name: "가능 초교", time: "04:20"},
                            {name: "세븐일레븐", time: "04:25"},
                            {name: "가능1동 주민센터", time: "04:26"},
                            {name: "크리스탈 제과점", time: "04:27"},
                            {name: "가능 프라자", time: "04:28"},
                            {name: "하나 은행", time: "04:29"},
                            {name: "의고", time: "11:05"},
                            {name: "현대 힐스테이트", time: "11:05"},
                            {name: "누가 약국", time: "04:33"},
                            {name: "새마을 금고", time: "04:34"},
                            {name: "스위스 베이커리", time: "04:35"},
                            {name: "풍전 빌라", time: "04:26"},
                            {name: "교회 도착", time: "04:44", isArrival: true},
                        ],
                    }
                ],
            }, {
                id: "route-5",
                number: "수요 저녁",
                name: "가능,녹양방면",
                contact: "김은배 장로 010-6227-6418",
                schedules: [
                    {
                        service: "수요 저녁",
                        departure: "18:35 출발",
                        stops: [
                            {name: "가능 초교", time: "18:50"},
                            {name: "세븐일레븐", time: "18:55"},
                            {name: "가능1동 주민센터", time: "18:56"},
                            {name: "크리스탈 제과점", time: "18:57"},
                            {name: "가능 프라자", time: "18:58"},
                            {name: "하나 은행", time: "18:59"},
                            {name: "의고", time: "19:03"},
                            {name: "현대 힐스테이트", time: "19:04"},
                            {name: "누가 약국", time: "19:07"},
                            {name: "새마을 금고", time: "19:08"},
                            {name: "타이어 마을", time: "19:10"},
                            {name: "교회 도착", time: "19:15", isArrival: true},
                        ],
                    }
                ],
            }, {
                id: "route-6",
                number: "주일 오후",
                name: "가능,녹양방면",
                contact: "김은배 장로 010-6227-6418",
                schedules: [
                    {
                        service: "주일 오후",
                        departure: "13:35 출발",
                        stops: [
                            {name: "가능 초교", time: "13:50"},
                            {name: "세븐일레븐", time: "13:55"},
                            {name: "가능1동 주민센터", time: "13:56"},
                            {name: "크리스탈 제과점", time: "13:57"},
                            {name: "가능 프라자", time: "13:58"},
                            {name: "하나 은행", time: "13:59"},
                            {name: "의고", time: "14:03"},
                            {name: "현대 힐스테이트", time: "14:04"},
                            {name: "누가 약국", time: "14:07"},
                            {name: "새마을 금고", time: "14:08"},
                            {name: "타이어 마을", time: "14:10"},
                            {name: "교회 도착", time: "14:15", isArrival: true},
                        ],
                    }
                ],
            }, {
                id: "route-7",
                number: "금요 철야",
                name: "가능,녹양방면",
                contact: "김은배 장로 010-6227-6418",
                schedules: [
                    {
                        service: "금요 철야",
                        departure: "21:05 출발",
                        stops: [
                            {name: "가능 초교", time: "21:20"},
                            {name: "세븐일레븐", time: "21:25"},
                            {name: "가능1동 주민센터", time: "21:26"},
                            {name: "크리스탈 제과점", time: "21:27"},
                            {name: "가능 프라자", time: "21:28"},
                            {name: "하나 은행", time: "21:29"},
                            {name: "의고", time: "21:33"},
                            {name: "현대 힐스테이트", time: "21:34"},
                            {name: "누가 약국", time: "21:37"},
                            {name: "새마을 금고", time: "21:38"},
                            {name: "타이어 마을", time: "21:40"},
                            {name: "교회 도착", time: "21:45", isArrival: true},
                        ],
                    },
                ],
            },
        ]

        if (isLoading) {
            return (
                <div
                    className="loading-container"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        background: "#fafafa",
                    }}
                >
                    <div
                        style={{
                            width: "50px",
                            height: "50px",
                            border: "3px solid #f3f3f3",
                            borderTop: "3px solid #ff6b35",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                        }}
                    ></div>
                </div>
            )
        }

        return (
            <section className="pf-page directions-page">
                <PC>
                    <section className="directions-content">
                        <div className="background">
                            <div className="layout">
                                {/* 페이지 헤더 */}
                                <div className="page-header">
                                    <h1>오시는 길</h1>
                                    <p>
                                        성실교회로 오시는 다양한 방법을 안내해드립니다. 셔틀버스와 대중교통을 이용하여 편리하게 방문하세요.
                                    </p>
                                </div>

                                {/* 지도 섹션 */}
                                <div className="directions-map">
                                    <div className="map-header">
                                        <div className="map-icon">📍</div>
                                        <div className="map-info">
                                            <h3>성실교회 위치</h3>
                                            <p>경기도 의정부시 입석로 24 (가능동)</p>
                                        </div>
                                    </div>
                                    <div className="map-container">
                                        <KakaoMap lat="37.7560753" lng="127.0229565"/>
                                    </div>
                                </div>

                                {/* 정보 그리드 */}
                                <div className="info-grid">
                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚗</div>
                                            <h3>자가용 이용</h3>
                                        </div>
                                        <div className="info-item">
                                            <h4>네비게이션 검색</h4>
                                            <p>
                                                <strong>'성실교회'</strong> 또는 <strong>'경기도 의정부시 입석로 24'</strong>를 입력하시면 쉽게
                                                찾아오실 수 있습니다.
                                            </p>
                                        </div>
                                        <div className="info-item">
                                            <h4>주차 안내</h4>
                                            <p>교회 내 주차공간이 마련되어 있으니 안전하게 주차하시기 바랍니다.</p>
                                        </div>
                                    </div>

                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚌</div>
                                            <h3>대중교통 이용</h3>
                                        </div>
                                        <div className="info-item">
                                            <h4>버스 이용</h4>
                                            <p>
                                                <strong>11번 버스</strong>를 이용하여 <strong>'한도병원'</strong> 정류장에서 하차 후 도보 3분
                                                거리입니다.
                                            </p>
                                        </div>
                                        <div className="info-item">
                                            <h4>지하철 + 버스</h4>
                                            <p>의정부역에서 버스로 환승하여 오시는 방법도 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* 셔틀버스 섹션 */}
                                <div className="shuttle-section">
                                    <div className="section-header">
                                        <div className="section-icon">🚐</div>
                                        <h3>셔틀버스 안내</h3>
                                        <p>주일예배 시간에 맞춰 운행되는 셔틀버스를 이용하시면 편리하게 교회에 오실 수 있습니다.</p>
                                    </div>

                                    <div className="shuttle-routes">
                                        {shuttleRoutes.map((route) => (
                                            <div key={route.id} className="route-card">
                                                <div className="route-header">
                                                    <div className="route-number">{route.number}</div>
                                                    <div className="route-name">{route.name}</div>
                                                    <p className="route-contact">{route.contact}</p>
                                                </div>
                                                <div className="route-schedule">
                                                    {route.schedules.map((schedule, index) => (
                                                        <div key={index} className="schedule-item">
                                                            <div className="schedule-header">
                                                                <span
                                                                    className="schedule-title">{schedule.service}</span>
                                                                <span
                                                                    className="schedule-time">{schedule.departure}</span>
                                                            </div>
                                                            <div className="schedule-stops">
                                                                {schedule.stops.map((stop, stopIndex) => (
                                                                    <div key={stopIndex}
                                                                         className={`stop ${stop.isArrival ? "arrival" : ""}`}>
                                                                        <div className="stop-name">{stop.name}</div>
                                                                        <div className="stop-time">{stop.time}</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </PC>

                <Notebook>
                    <section className="directions-content">
                        <div className="background">
                            <div className="layout">
                                {/* 페이지 헤더 */}
                                <div className="page-header">
                                    <h1>오시는 길</h1>
                                    <p>성실교회로 오시는 다양한 방법을 안내해드립니다.</p>
                                </div>

                                {/* 지도 섹션 */}
                                <div className="directions-map">
                                    <div className="map-header">
                                        <div className="map-icon">📍</div>
                                        <div className="map-info">
                                            <h3>성실교회 위치</h3>
                                            <p>경기도 의정부시 입석로 24 (가능동)</p>
                                        </div>
                                    </div>
                                    <div className="map-container">
                                        <KakaoMap lat="37.7560753" lng="127.0229565"/>
                                    </div>
                                </div>

                                {/* 정보 그리드 */}
                                <div className="info-grid">
                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚗</div>
                                            <h3>자가용 이용</h3>
                                        </div>
                                        <div className="info-item">
                                            <h4>네비게이션 검색</h4>
                                            <p>
                                                <strong>'성실교회'</strong> 또는 <strong>'경기도 의정부시 입석로 24 (가능동)'</strong>를
                                                입력하세요.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚌</div>
                                            <h3>대중교통 이용</h3>
                                        </div>
                                        <div className="info-item">
                                            <h4>버스 이용</h4>
                                            <p>
                                                <strong>11번 버스</strong> → <strong>'한도병원'</strong> 하차 → 도보 3분
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 셔틀버스 섹션 */}
                                <div className="shuttle-section">
                                    <div className="section-header">
                                        <div className="section-icon">🚐</div>
                                        <h3>셔틀버스 안내</h3>
                                        <p>주일예배 시간에 맞춰 운행되는 셔틀버스를 이용하세요.</p>
                                    </div>

                                    <div className="shuttle-routes">
                                        {shuttleRoutes.map((route) => (
                                            <div key={route.id} className="route-card">
                                                <div className="route-header">
                                                    <div className="route-number">{route.number}</div>
                                                    <div className="route-name">{route.name}</div>
                                                    <p className="route-contact">{route.contact}</p>
                                                </div>
                                                <div className="route-schedule">
                                                    {route.schedules.map((schedule, index) => (
                                                        <div key={index} className="schedule-item">
                                                            <div className="schedule-header">
                                                                <span
                                                                    className="schedule-title">{schedule.service}</span>
                                                                <span
                                                                    className="schedule-time">{schedule.departure}</span>
                                                            </div>
                                                            <div className="schedule-stops">
                                                                {schedule.stops.map((stop, stopIndex) => (
                                                                    <div key={stopIndex}
                                                                         className={`stop ${stop.isArrival ? "arrival" : ""}`}>
                                                                        <div className="stop-name">{stop.name}</div>
                                                                        <div className="stop-time">{stop.time}</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Notebook>

                <Tablet>
                    <section className="directions-content">
                        <div className="background">
                            <div className="layout">
                                {/* 페이지 헤더 */}
                                <div className="page-header">
                                    <h1>오시는 길</h1>
                                    <p>성실교회로 오시는 방법을 안내합니다.</p>
                                </div>

                                {/* 지도 섹션 */}
                                <div className="directions-map">
                                    <div className="map-header">
                                        <div className="map-icon">📍</div>
                                        <div className="map-info">
                                            <h3>성실교회</h3>
                                            <p>경기도 의정부시 입석로 24</p>
                                        </div>
                                    </div>
                                    <div className="map-container">
                                        <KakaoMap lat="37.7560753" lng="127.0229565"/>
                                    </div>
                                </div>

                                {/* 정보 그리드 */}
                                <div className="info-grid">
                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚗</div>
                                            <h3>자가용</h3>
                                        </div>
                                        <div className="info-item">
                                            <p>
                                                <strong>'성실교회'</strong> 또는 <strong>'경기도 의정부시 입석로 24 (가능동)'</strong>를
                                                입력하세요.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚌</div>
                                            <h3>대중교통</h3>
                                        </div>
                                        <div className="info-item">
                                            <p>
                                                <strong>11번 버스</strong> → 한도병원 하차
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 셔틀버스 섹션 */}
                                <div className="shuttle-section">
                                    <div className="section-header">
                                        <div className="section-icon">🚐</div>
                                        <h3>셔틀버스</h3>
                                    </div>

                                    <div className="shuttle-routes">
                                        {shuttleRoutes.slice(0, 2).map((route) => (
                                            <div key={route.id} className="route-card">
                                                <div className="route-header">
                                                    <div className="route-number">{route.number}</div>
                                                    <div className="route-name">{route.name}</div>
                                                </div>
                                                <div className="route-schedule">
                                                    {route.schedules.map((schedule, index) => (
                                                        <div key={index} className="schedule-item">
                                                            <div className="schedule-header">
                                                                <span
                                                                    className="schedule-title">{schedule.service}</span>
                                                                <span
                                                                    className="schedule-time">{schedule.departure}</span>
                                                            </div>
                                                            <div className="schedule-stops">
                                                                {schedule.stops.slice(0, 6).map((stop, stopIndex) => (
                                                                    <div key={stopIndex}
                                                                         className={`stop ${stop.isArrival ? "arrival" : ""}`}>
                                                                        <div className="stop-name">{stop.name}</div>
                                                                        <div className="stop-time">{stop.time}</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Tablet>

                <Mobile>
                    <section className="directions-content">
                        <div className="background">
                            <div className="layout">
                                {/* 페이지 헤더 */}
                                <div className="page-header">
                                    <h1>오시는 길</h1>
                                    <p>성실교회 방문 안내</p>
                                </div>

                                {/* 지도 섹션 */}
                                <div className="directions-map">
                                    <div className="map-header">
                                        <div className="map-icon">📍</div>
                                        <div className="map-info">
                                            <h3>성실교회</h3>
                                            <p>의정부시 입석로 24</p>
                                        </div>
                                    </div>
                                    <div className="map-container">
                                        <KakaoMap lat="37.7560753" lng="127.0229565"/>
                                    </div>
                                </div>

                                {/* 정보 그리드 */}
                                <div className="info-grid">
                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚗</div>
                                            <h3>자가용</h3>
                                        </div>
                                        <div className="info-item">
                                            <p>
                                                <strong>'성실교회'</strong> 또는 <strong>'경기도 의정부시 입석로 24 (가능동)'</strong>를
                                                입력하세요.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="info-section">
                                        <div className="section-header">
                                            <div className="section-icon">🚌</div>
                                            <h3>버스</h3>
                                        </div>
                                        <div className="info-item">
                                            <p>
                                                <strong>11번</strong> → 한도병원 → 도보3분
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* 모바일 셔틀버스 탭 */}
                                <div className="shuttle-section">
                                    <div className="section-header">
                                        <div className="section-icon">🚐</div>
                                        <h3>셔틀버스</h3>
                                    </div>

                                    <div className="mobile-tabs">
                                        <div className="tab-navigation">
                                            {shuttleRoutes.map((route, index) => (
                                                <button
                                                    key={route.id}
                                                    className={`tab-button ${this.state.activeTab === route.id ? "active" : ""}`}
                                                    data-tab={route.id}
                                                    onClick={() =>
                                                        this.switchTab(
                                                            route.id,
                                                            document.querySelectorAll(".tab-button"),
                                                            document.querySelectorAll(".tab-panel")
                                                        )
                                                    }
                                                >
                                                    {route.number}
                                                </button>
                                            ))}
                                        </div>

                                        <div className="tab-content">
                                            {shuttleRoutes.map((route, index) => (
                                                <div key={route.id} id={route.id}
                                                     className={`tab-panel ${index === 0 ? "active" : ""}`}>
                                                    <div className="mobile-route-info">
                                                        <div className="route-title">{route.name}</div>
                                                        <div className="route-description">{route.contact}</div>
                                                    </div>

                                                    <div className="mobile-schedule-list">
                                                        {route.schedules.map((schedule, scheduleIndex) => (
                                                            <div key={scheduleIndex} className="schedule-card">
                                                                <div className="card-header">
                                                                    <h4 className="service-name">{schedule.service}</h4>
                                                                    <span
                                                                        className="departure-time">{schedule.departure}</span>
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="stop-list">
                                                                        {schedule.stops.map((stop, stopIndex) => (
                                                                            <div
                                                                                key={stopIndex}
                                                                                className={`stop-item ${stop.isArrival ? "final-stop" : ""}`}
                                                                            >
                                                                                <span
                                                                                    className="stop-name">{stop.name}</span>
                                                                                <span
                                                                                    className="stop-time">{stop.time}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Mobile>
            </section>
        )
    }
}

export default Directions
